/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  CurvePAPTokensPriceProvider,
  CurvePAPTokensPriceProviderInterface,
} from "../CurvePAPTokensPriceProvider";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_providersRepository",
        type: "address",
      },
      {
        internalType: "contract ICurveLPTokensDetailsFetchersRepository",
        name: "_fetchersRepository",
        type: "address",
      },
      {
        internalType: "address",
        name: "_nullAddr",
        type: "address",
      },
      {
        internalType: "address",
        name: "_nativeWrappedAddr",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "EmptyWETHAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidFetchersRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidInterface",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidNumberOfCoinsInPool",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPoolConfiguration",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPriceProviderRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "MissingPoolReentrancyConfig",
    type: "error",
  },
  {
    inputs: [],
    name: "NonreentrantLockIsActive",
    type: "error",
  },
  {
    inputs: [],
    name: "NotSupported",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyManager",
    type: "error",
  },
  {
    inputs: [],
    name: "PoolForLPTokenNotFound",
    type: "error",
  },
  {
    inputs: [],
    name: "TokenAlreadyInitialized",
    type: "error",
  },
  {
    inputs: [],
    name: "UnsupportedPoolWithTwoLPs",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroPrice",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "LPTokenEnabled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_pool",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_gasLimit",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum ICurveReentrancyCheck.N_COINS",
        name: "_nCoins",
        type: "uint8",
      },
    ],
    name: "ReentrancyCheckConfigUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "MIN_GAS_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
    ],
    name: "assetSupported",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "coins",
    outputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isLPToken",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
    ],
    name: "getPoolUnderlyingCoins",
    outputs: [
      {
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
      {
        internalType: "address[8]",
        name: "coinsList",
        type: "address[8]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_pool",
        type: "address",
      },
    ],
    name: "isLocked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lpTokenPool",
    outputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isMeta",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "poolReentrancyConfig",
    outputs: [
      {
        internalType: "uint128",
        name: "gasLimit",
        type: "uint128",
      },
      {
        internalType: "enum ICurveReentrancyCheck.N_COINS",
        name: "nCoins",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProviderPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "quoteToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_pool",
        type: "address",
      },
      {
        internalType: "uint128",
        name: "_gasLimit",
        type: "uint128",
      },
      {
        internalType: "enum ICurveReentrancyCheck.N_COINS",
        name: "_nCoins",
        type: "uint8",
      },
    ],
    name: "setReentrancyVerificationConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
    ],
    name: "setupAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_lpTokens",
        type: "address[]",
      },
    ],
    name: "setupAssets",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type CurvePAPTokensPriceProviderConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: CurvePAPTokensPriceProviderConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class CurvePAPTokensPriceProvider__factory extends ContractFactory {
  constructor(...args: CurvePAPTokensPriceProviderConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "CurvePAPTokensPriceProvider";
  }

  deploy(
    _providersRepository: string,
    _fetchersRepository: string,
    _nullAddr: string,
    _nativeWrappedAddr: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<CurvePAPTokensPriceProvider> {
    return super.deploy(
      _providersRepository,
      _fetchersRepository,
      _nullAddr,
      _nativeWrappedAddr,
      overrides || {}
    ) as Promise<CurvePAPTokensPriceProvider>;
  }
  getDeployTransaction(
    _providersRepository: string,
    _fetchersRepository: string,
    _nullAddr: string,
    _nativeWrappedAddr: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _providersRepository,
      _fetchersRepository,
      _nullAddr,
      _nativeWrappedAddr,
      overrides || {}
    );
  }
  attach(address: string): CurvePAPTokensPriceProvider {
    return super.attach(address) as CurvePAPTokensPriceProvider;
  }
  connect(signer: Signer): CurvePAPTokensPriceProvider__factory {
    return super.connect(signer) as CurvePAPTokensPriceProvider__factory;
  }
  static readonly contractName: "CurvePAPTokensPriceProvider";
  public readonly contractName: "CurvePAPTokensPriceProvider";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CurvePAPTokensPriceProviderInterface {
    return new utils.Interface(_abi) as CurvePAPTokensPriceProviderInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CurvePAPTokensPriceProvider {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as CurvePAPTokensPriceProvider;
  }
}
